module.exports = __webpack_public_path__ + "img/feature-icon2.2b1619b.svg";